
import axios from '@/axios.js'

export default {

  fetchPersediaan ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios.get(`/persediaan/${payload}`)
        .then((response) => {
          commit('SET_TASKS', response.data.data)
          resolve(response.data)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchPersediaanGudang ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios.get(`/persediaan-gudang/${payload.persediaan}/${payload.gudang}`)
        .then((response) => {
          commit('SET_TASKS', response.data.data)
          resolve(response.data)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchPersediaanHistori ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios.get(`/persediaan-histori/${payload.persediaan}/${payload.gudang}`)
        .then((response) => {
          commit('SET_HISTORIS', response.data.data)
          resolve(response.data)
        })
        .catch((error) => { reject(error) })
    })
  },
  pemindahanAdd ({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.post('/pemindahan-add', data)
      .then((response) => {
        commit('ADD_PERSEDIAAN', response.data.data)
        resolve(response.data)
      })
      .catch((error) => { reject(error) })
    })
  },
  pemindahanUpdate ({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.post('/pemindahan-add', data)
      .then((response) => {
        commit('UPDATE_PERSEDIAAN', response.data.data)
        resolve(response.data)
      })
      .catch((error) => { reject(error) })
    })
  },
  pemindahanRemove ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios.post('/pemindahan-remove', payload)
      .then((response) => {
        commit('REMOVE_PERSEDIAAN', payload)
        resolve(response.data)
      })
      .catch((error) => { reject(error) })
    })
  },

}
